<div class="login-body">
    <div class="login-panel surface-card p-6 shadow-2 border-round w-full lg:w-4">
        <form #authForm="ngForm" (ngSubmit)="submitForm()">
            <div class="text-center mb-5">                
                <img src="assets/layout/images/login/logo-login.png" alt="{{appConfig.app.name}}" height="100h" class="mb-3 responsive">
                <div class="text-900 text-3xl font-medium mb-31">{{ appConfig.app.subtitle }}</div>
                <!--<span class="text-600 font-medium line-height-3">{{ appConfig.app.vozmarca }}</span>-->
                <span class="text-600 font-medium line-height-3"> {{ appConfig.app.version.id }} {{ appConfig.app.version.nombre }}</span>
            </div>
            <div *ngIf="alertarActualizacion">
                <div class="flex align-items-start p-4 bg-yellow-100 border-round border-1 border-yellow-300">
                    <i class="pi pi-exclamation-triangle text-yellow-900 text-2xl mr-3"></i>
                    <div class="mr-3">
                        <div class="text-yellow-900 font-medium text-xl mb-2 line-height-1">¡Hay una actualización disponible!</div>
                        <p class="m-0 p-0 text-yellow-700 mb-3 line-height-3"><strong>¡Dale! Hicimos ajustes para que tu vida sea aún más facíl.</strong></p>
                        <a class="font-medium text-white-800 hover:text-white mr-4 no-underline cursor-pointer select-none transition-colors transition-duration-150"
                           (click)="actualizarVersion(serverVersionNumber);">Haz clic para actualizar FacturaFácil</a>
                    </div>
                </div>
            </div>
            <div  class="p-fluid p-formgrid p-grid p-input-filled">
                <label for="email1" class="block text-900 font-medium mb-2">Correo electrónico</label>
                <span class="p-input-icon-left">
                    <i class="pi pi-user"></i>
                    <input id="email1" name="email1" type="text" [(ngModel)]="username" pInputText class="w-full mb-3" placeholder="Ingrese su correo electrónico" required="true">
                </span>
                <label for="password1" class="block text-900 font-medium mb-2">Contraseña</label>

                <span class="p-input-icon-left">
                    <i class="pi pi-lock"></i>
                    <input id="password1" type="{{typePassword}}" 
                           [(ngModel)]="password" [ngModelOptions]="{standalone: true}" pInputText class="w-full mb-3" 
                           placeholder="Ingrese su contraseña" required="true">
                </span>
                <span class="p-input-right">
                    <input type="checkbox" (click)="verContrasenia($event)">Mostrar contraseña
                </span>

                <div class="flex align-items-center justify-content-between mb-12">
                    <p-messages [(value)]="msgs"></p-messages>
                </div>
                <br>
                <button pButton pRipple label="Ingresar" icon="pi pi-user" class="w-full" style="background-color: #506bf2; color: white;">
                </button>
                <div class="flex align-items-end justify-content-between mb-6">
                    <div class="flex align-items-center">
                    </div>
                    <a class="font-medium no-underline ml-2 text-right cursor-pointer" (click)="irAConfirmarCambiarContrasenia($event);" style="background-color: #fff !important; color: #1f2e4d;">Olvidé mi contraseña</a>
                </div>
            </div>
            <div class="text-center mb-1">
                <span class="text-400 font-medium line-height-3">¿Quiero ser FacturaFácil Ecuador?</span>
                <button pButton pRipple label="Registrarme" icon="pi pi-key" class="w-full" style="background-color: #ffb621; color: #1f2e4d;" (click)="irARegistrar($event);"></button>
                <div class="flex align-items-end justify-content-between mb-1 mt-3">
                    <div class="flex align-items-center">
                    </div>

                    <a class="font-medium no-underline ml-2 text-right cursor-pointer" href="https://www.facturafacilecuador.com/#contact" target="_blank" style="background-color: #fff !important; color: #1f2e4d;">
                        <img src="../../assets/layout/images/whatsapp2.png" alt="Asistencia" class="mb-1 responsive" style="width:30px;">

                    </a>


                </div>
            </div>
        </form>
    </div>
</div>